import MeeyImage from "@/components/MeeyImage";
import PopOver from "@/components/PopOver";
import { STATIC_DOMAIN } from "@/constants/environment";
import { DEFAULT_LOGO_PROJECT } from "@/constants/project-constant";
import { ProjectReview } from "Models";
import Link from "next/link";

interface IHeaderDetailReview {
  project: ProjectReview;
}

const HeaderDetailReview = ({ project }: IHeaderDetailReview) => {
  return (
    <div className="w-full h-fit bg-white shadow-light-1 sticky top-[3.5rem] z-20">
      <div className="flex items-center justify-between gap-6 py-2 layout">
        <div className="flex items-center gap-2">
          <MeeyImage
            src={
              project?.logo
                ? project?.logo?.uri
                : `${STATIC_DOMAIN}/${DEFAULT_LOGO_PROJECT}`
            }
            alt={project?.title}
            resizeOnFly={!!project?.logo?.uri}
            resizeOptions={{
              width: 0,
              height: 108,
            }}
            className="rounded-full h-9 w-9 border-2 border-solid border-grey-50 object-contain"
          />
          <PopOver
            trigger="hover"
            dropdownClassName="mt-2 !p-0 rounded !bg-transparent"
            content={
              <div className="py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word">
                {project?.title}
              </div>
            }
            position="bottom-left">
            <Link
              href={`/project/${project.slug}-${
                project.shortId ? project.shortId : project._id
              }`}>
              <span className="text-fs-16 font-semibold text-grey-700">
                {project?.title?.length > 80
                  ? project?.title.substring(0, 80) + "..."
                  : project?.title}
              </span>
            </Link>
          </PopOver>
        </div>
        {project?.totalHotReview ? (
          <div className="flex items-center gap-2">
            {project?.voteScore ? (
              <div className="flex items-center gap-1">
                <div className="text-fs-20 font-semibold text-grey-700">
                  {Number.isInteger(project?.voteScore)
                    ? project?.voteScore
                    : project?.voteScore?.toFixed(1)}
                </div>
                <i className="mrv mrv-star text-[#FFC633] text-fs-20"></i>
              </div>
            ) : null}

            <span className="text-fs-16 text-grey-700">
              ({project?.totalHotReview} reviews)
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default HeaderDetailReview;
